// capacitor.js - Native app specific functionality
import { Capacitor } from '@capacitor/core';
import { StatusBar, Style } from '@capacitor/status-bar';
import { SplashScreen } from '@capacitor/splash-screen';
import { Keyboard } from '@capacitor/keyboard';
import { App } from '@capacitor/app';

// Initialize Capacitor features when the app starts
document.addEventListener('DOMContentLoaded', function() {
  if (Capacitor.isNativePlatform()) {
    initializeNativeFeatures();
  }
});

async function initializeNativeFeatures() {
  try {
    // Hide splash screen
    await SplashScreen.hide();
    
    // Configure status bar
    await StatusBar.setStyle({ style: Style.Dark });
    await StatusBar.setBackgroundColor({ color: '#000000' });
    
    // Handle keyboard events
    Keyboard.addListener('keyboardWillShow', info => {
      document.body.style.transform = `translateY(-${info.keyboardHeight}px)`;
    });
    
    Keyboard.addListener('keyboardWillHide', () => {
      document.body.style.transform = 'translateY(0px)';
    });
    
    // Handle app state changes
    App.addListener('appStateChange', ({ isActive }) => {
      console.log('App state changed. Is active?', isActive);
    });
    
    // Handle app URL changes (for deep linking)
    App.addListener('appUrlOpen', data => {
      console.log('App opened with URL:', data);
    });
    
    // Handle back button for Android
    App.addListener('backButton', ({ canGoBack }) => {
      if (!canGoBack) {
        App.exitApp();
      } else {
        window.history.back();
      }
    });
    
    console.log('Capacitor native features initialized');
  } catch (error) {
    console.error('Error initializing Capacitor features:', error);
  }
}

// Disable context menu on native platforms
if (Capacitor.isNativePlatform()) {
  document.addEventListener('contextmenu', function(e) {
    e.preventDefault();
  });
  
  // Disable text selection drag
  document.addEventListener('selectstart', function(e) {
    if (e.target.tagName !== 'INPUT' && e.target.tagName !== 'TEXTAREA') {
      e.preventDefault();
    }
  });
}

export { initializeNativeFeatures };
